/**
 * Resolve event listing vs detail routes using pathname only.
 * Query params (fbclid, startDate, startTime, etc.) must not affect routing.
 */
export function getEventRouteMatch(
  path: string,
  eventPageFullPath: string | false | '' | undefined
) {
  if (!eventPageFullPath) {
    return {
      isEventListingPage: false,
      eventDetailSlug: null as string | null
    };
  }

  if (path === eventPageFullPath) {
    return {
      isEventListingPage: true,
      eventDetailSlug: null
    };
  }

  const eventDetailPrefix = `${eventPageFullPath}/`;
  if (path.startsWith(eventDetailPrefix)) {
    return {
      isEventListingPage: false,
      eventDetailSlug: path.slice(eventDetailPrefix.length)
    };
  }

  return {
    isEventListingPage: false,
    eventDetailSlug: null
  };
}

export function useEventRouteMatch() {
  const route = useRoute();
  const { $fullpath } = useSiteSettings();
  const { siteParts } = storeToRefs(useSettingsStore());

  const eventPageFullPath =
    siteParts.value && $fullpath(siteParts.value?.general?.eventPage?._ref);

  return {
    eventPageFullPath,
    ...getEventRouteMatch(route.path, eventPageFullPath)
  };
}
